export function LandingFlow() {
  return (
    <section className="wf-flow" id="how-it-works">
      <div className="wf-two-columns">
        <div>
          <h2>Three passes from contract to counterparty.</h2>
          <p>
            Waterfall reads your contracts, brings sales into each reporting window, and shows its
            work every step of the way.
          </p>
        </div>
        <ol>
          <li>Contract terms</li>
          <li>Waterfall calculations</li>
          <li>Statements</li>
        </ol>
      </div>
    </section>
  );
}
